import { colourStaticGrey } from "@ingka/variables/colours-css";
import React from "react";
import styled from "styled-components";

const LayoutContainer = styled.div`
	display: grid;
	height: 100vh;
	grid-template-areas: "header content footer";
	grid-template-columns: 1fr;
	grid-template-rows: auto 1fr auto;
	border: 1px solid ${colourStaticGrey};
`;

const Main = styled.div`
	min-height: 0;
	height: 100vh;
	overflow: hidden;
`;

export const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<LayoutContainer>
			<Main>{children}</Main>
		</LayoutContainer>
	);
};
